
import Vue from "vue";
import request from "@/utils/request";
import Breadcrump from "@/components/common/Breadcrump.vue";

export default Vue.extend({
  components: { Breadcrump },

  props: {
    id: {
      type: [String, Number],
      default: null
    }
  },

  data() {
    return {
      valid: true,
      loading: false,
      errors: [] as string[],

      form: {
        gameWon: true,
        message: "",
        title: ""
      },
      selectedTags: [] as string[]
    };
  },

  computed: {
    isEdit(): boolean {
      return !!this.id && this.id !== "add";
    },

    crumbs(): any[] {
      const base = [
        { text: "خانه", href: "/", disabled: false },
        { text: "پیامک‌های بازی", href: "/game-sms", disabled: false }
      ];
      return this.isEdit
        ? [...base, { text: "ویرایش پیامک", disabled: true }]
        : [...base, { text: "افزودن پیامک جدید", disabled: true }];
    }
  },

  mounted() {
    if (this.isEdit) {
      this.loadSmsData();
    }
  },

  methods: {
    async loadSmsData() {
      this.loading = true;
      try {
        const res = await request.get(`/GameSms/${this.id}`);
        const data = res.data.result;
        this.form.gameWon = data.gameWon;
        this.form.message = data.message;
        this.form.title = data.title;
      } catch (error) {
        this.errors.push("خطا در دریافت اطلاعات");
      } finally {
        this.loading = false;
      }
    },

    async submitForm() {
      this.errors = [];
      const formRef = this.$refs.form as any;
      if (!formRef.validate()) return;

      if (!this.form.message) {
        this.errors.push("متن پیامک الزامی است");
        return;
      }
      if (!this.form.title) {
        this.errors.push("عنوان پیامک الزامی است");
        return;
      }

      this.loading = true;

      try {
        const url = this.isEdit ? `/GameSms/${this.id}` : "/GameSms";
        const method = this.isEdit ? "put" : "post";

        const payload = {
          gameWon: this.form.gameWon,
          message: this.form.message,
          title: this.form.title
        };

        const response = await request[method](url, payload);

        this.$router.push("/game-sms");
      } catch (error) {
        const msg = "خطا در ذخیره اطلاعات";
        this.errors.push(msg);
      } finally {
        this.loading = false;
      }
    }
  }
});
